exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".OJcJY{padding-right:0!important}.OWNPr{overflow-y:auto!important}", ""]);

// exports
exports.locals = {
	"adjustPaddingRight": "OJcJY",
	"child": "OWNPr"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":{"discardComments":{"removeAll":true}}}!./node_modules/postcss-loader/lib?{"config":{"path":"./tools/postcss.config.js"}}!./node_modules/sass-loader/lib/loader.js!./src/components/Layout/Layout.sass
// module id = 876
// module chunks = 0 1 2 3 4 5